import React from "react";
import svgPaths from "../../imports/svg-theme-icons";
import "./styles.scss";

interface ThemeToggleProps {
  isDarkMode: boolean;
  onToggle: () => void;
}

const ThemeToggle: React.FC<ThemeToggleProps> = ({ isDarkMode, onToggle }) => (
  <div
    className={`theme-toggle ${isDarkMode ? "theme-toggle--dark" : ""}`}
  >
    <button
      type="button"
      onClick={() => isDarkMode && onToggle()}
      className="theme-toggle__button"
      aria-label="Light mode"
    >
      <svg className="theme-toggle__icon" fill="none" preserveAspectRatio="none" viewBox="0 0 24 24">
        <rect fill={!isDarkMode ? "#11382E" : "#464861"} height="24" rx="12" width="24" />
        <path d={svgPaths.p5440c80} fill={!isDarkMode ? "#00C853" : "#E8E9F4"} />
      </svg>
    </button>

    <div className={`theme-toggle__divider ${isDarkMode ? "theme-toggle__divider--dark" : ""}`} />

    <button
      type="button"
      onClick={() => !isDarkMode && onToggle()}
      className="theme-toggle__button"
      aria-label="Dark mode"
    >
      <svg className="theme-toggle__icon" fill="none" preserveAspectRatio="none" viewBox="0 0 24 24">
        <rect fill={isDarkMode ? "#11382E" : "#A8A1A1"} height="24" rx="12" width="24" />
        <path d={svgPaths.p72978f0} fill={isDarkMode ? "#00C853" : "#FDFDFD"} />
      </svg>
    </button>
  </div>
);

export default ThemeToggle;
